import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  ActivityAddressService,
  AddressService,
  AddressWalklistService,
  Backend,
  ConfigSettingPage,
  DataService,
  DropService,
  EntitlementService,
  IPage,
  K2ViewPage,
  PermissionService,
  PrivilegeService,
  RoleService,
  TeamSalesRepService,
  TeamService,
  UserService,
  WalklistLPDSPageService,
  FsaAssignmentService,
} from '../index';
import { ConnectionPool } from './connectionPool';
import { PageTitles } from '../interfaces/types';

import { ENV, IEnvironment } from 'env/config';

@Injectable({ providedIn: 'root' })
export class D2CCentral {
  public static pool: ConnectionPool;
  private static app: D2CCentral;

  public lastURLBeforeLogin: string;
  private pages: IPage<any>[] = [];
  private readonly maxColumnsVisibility: number;
  private readonly backend: Backend;
  private readonly queryItemsLimit: number;

  constructor(
    private http: HttpClient,
    private dataService: DataService,
    @Inject(ENV) private env: IEnvironment
  ) {
    this.maxColumnsVisibility = env.app.tableMaxColumns;
    this.backend = env.api.backend;
    this.queryItemsLimit = env.app.pageSize;
  }

  public static get(): D2CCentral {
    return D2CCentral.app;
  }

  public initialize() {
    const { central, reproster, geoserver, k2view, d2cGeo } = this.backend;
    const conf = {
      http: this.http,
      maxCol: this.maxColumnsVisibility,
      queryItemsLimit: this.queryItemsLimit,
    };

    // this pool is used to get services
    D2CCentral.pool = new ConnectionPool(this.env, this.dataService);

    this.addPage(new TeamService(this.env, reproster, conf));
    this.addPage(new TeamSalesRepService(reproster, conf));
    this.addPage(
      new DropService(central, conf, new TeamSalesRepService(reproster, conf))
    );
    //this.addPage(new KnockService(central, conf));
    this.addPage(new UserService(central, conf));
    this.addPage(new PermissionService(central, conf));
    this.addPage(new EntitlementService(central, conf));
    this.addPage(new RoleService(central, conf));
    this.addPage(new PrivilegeService(central, conf));
    this.addPage(new AddressService(central, conf));
    this.addPage(new ConfigSettingPage(central, conf));
    this.addPage(new AddressWalklistService(d2cGeo, conf));
    this.addPage(new FsaAssignmentService(central, conf));
    this.addPage(
      new ActivityAddressService(
        central,
        conf,
        this.getPage(PageTitles.addressWalklist)
      )
    );
    this.addPage(new K2ViewPage(this.env, k2view, conf));
    this.addPage(
      new WalklistLPDSPageService(
        this.env,
        central,
        conf,
        new K2ViewPage(this.env, k2view, conf)
      )
    );
  }

  public addPage<T>(page: IPage<T>) {
    this.pages.push(page);
  }

  public getPage<T>(title: string): IPage<T> {
    return this.pages.filter((p) => p.getTitle() === title)[0];
  }

  public getPool(): ConnectionPool {
    return D2CCentral.pool;
  }

  public getBackendConf(): Backend {
    return this.backend;
  }
}
